import { apiBaseUrl } from '../../../core/globalVariables';

import React, { useEffect, useState } from 'react';

import { fmesh, fullmesh } from '../../../core/globalVariables.js';

import { TiTick } from "react-icons/ti";

import { FaPencilAlt } from "react-icons/fa";

const AlterNumericMetricsInline = ({
  globalState,
  globalRefs,
  valuePropertyName
}) => {

  const toastRef = globalRefs.toastRef;

  const [inputValue, setInputValue] = useState('');
  const [selectedKey, setSelectedKey] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const longstandingGeoJSONRef =
    globalRefs.longstandingGeoJSONRef;

  const polygonCustomLayerRef =
    globalRefs.polygonCustomLayerRef;

  const multuGroupSelectedArray =
    globalState.multuGroupSelectedArray;

  const setIsLoadingNewGeoJSONFromAnUpdate =
    globalState.setIsLoadingNewGeoJSONFromAnUpdate;

  const setAPIReportMessage =
    globalState.setAPIReportMessage;

  const setRecentChangeList =
    globalState.setRecentChangeList;

  const landKeySelectedKey =
    globalState.landKeySelectedKey;

  const selectedMetric =
    globalState.selectedMetric;

  const selectedYearEditing =
    globalState.selectedYearEditing;

  const setSelectedYearEditing =
    globalState.setSelectedYearEditing;

  const currentMapIdRef =
    globalRefs.currentMapIdRef;

  const srid = 4326;

  const userIsMapOwner =
    globalState.userIsMapOwner;

  const setUserIsMapOwner =
    globalState.setUserIsMapOwner;

  useEffect(() => {

    if (landKeySelectedKey) {
      setSelectedKey(landKeySelectedKey);
    }

  }, [landKeySelectedKey]);

  useEffect(() => {

    if (
      !selectedYearEditing ||
      !selectedKey ||
      !selectedMetric
    ) {
      return;
    }

    const geojson =
      longstandingGeoJSONRef.current;

    const feature =
      geojson.features.find(
        f =>
          multuGroupSelectedArray.includes(
            f.skylark_id
          )
      );

    const value =
      feature
        ?.feature_data_simple_timeseries
      ?.[selectedMetric]
      ?.[selectedYearEditing] ?? '';

    setInputValue(value);

  }, [
    selectedYearEditing,
    selectedKey,
    selectedMetric,
    multuGroupSelectedArray
  ]);

  // -----------------------------
  // ENTER EDIT MODE
  // -----------------------------

  const handleEdit = () => {
    setIsEditing(true);
  };

  // -----------------------------
  // APPLY VALUE
  // -----------------------------

  const applyNumericValue = async () => {

    if (
      !selectedMetric ||
      !selectedYearEditing
    ) {
      return;
    }

    if (
      inputValue === '' ||
      isNaN(Number(inputValue))
    ) {
      return;
    }

    const numericValue =
      Number(inputValue);

    setIsLoadingNewGeoJSONFromAnUpdate(true);

    setAPIReportMessage(
      `Setting value to ${numericValue}...`
    );

    try {

      const updatedGeoJSON =
        structuredClone(
          longstandingGeoJSONRef.current
        );

      const selectedTimestampMs =
        new Date(
          selectedYearEditing
        ).getTime();

      const featuresToPatch = [];

      multuGroupSelectedArray.forEach(
        (skylarkId) => {

          const feature =
            updatedGeoJSON.features.find(
              f =>
                f.skylark_id === skylarkId
            );

          if (!feature) {
            return;
          }

          const series =
            feature
              .feature_data_simple_timeseries
            ?.[selectedMetric];

          if (!series) {
            return;
          }

          Object.keys(series).forEach(
            (timestamp) => {

              const tsMs =
                new Date(timestamp).getTime();

              if (tsMs >= selectedTimestampMs) {
                series[timestamp] =
                  numericValue;
              }

            }
          );
          featuresToPatch.push({
            skylark_id: feature.skylark_id,
            feature_data_simple_timeseries:
              feature.feature_data_simple_timeseries
          });

        }
      );

      if (featuresToPatch.length === 0) {

        setIsLoadingNewGeoJSONFromAnUpdate(false);

        setAPIReportMessage(
          'No features to update'
        );

        return;
      }

      // -----------------------------
      // PATCH DIRECTLY TO HARrier API
      // -----------------------------

      const token =
        localStorage.getItem('token');

      if (!token) {
        throw new Error(
          'No token in local storage'
        );
      }

      const mapId =
        currentMapIdRef.current;

      if (!mapId) {
        throw new Error(
          'No current map ID'
        );
      }

      const url =
        `${apiBaseUrl}/api/maps/${mapId}/features?srid=${srid}`;

      console.log(
        'PATCH map features:',
        url
      );

      const response =
        await fetch(
          url,
          {
            method: "PATCH",

            headers: {
              Authorization:
                `Bearer ${token}`,

              "Content-Type":
                "application/json",
            },

            body:
              JSON.stringify(
                featuresToPatch
              ),
          }
        );

      if (!response.ok) {

        const errorText =
          await response.text();

        toastRef.current(
          "Failed to Update Feature String Value"
        );

        throw new Error(
          `PATCH failed: ${response.status} ${errorText}`
        );
      }

      toastRef.current(
        "Successfully Updated Feature String Value"
      );

      await response.json();

      // -----------------------------
      // UPDATE LOCAL STATE AFTER SUCCESS
      // -----------------------------

      longstandingGeoJSONRef.current =
        updatedGeoJSON;

      setRecentChangeList(prev => [
        ...prev,

        featuresToPatch.map(f => ({
          toc: 'Value Change',
          newFeatureChange: f
        }))

      ].slice(-20));

      setTimeout(() => {

        fmesh.children = [];

        fullmesh.remove(fmesh);

        polygonCustomLayerRef.current.createShapes(
          longstandingGeoJSONRef.current,
          selectedYearEditing
        );

        polygonCustomLayerRef.current
          .getRandomPolygonColor(
            landKeySelectedKey
          );

        polygonCustomLayerRef.current
          .removeFeatureOpacities(
            fmesh,
            multuGroupSelectedArray
          );

        setIsLoadingNewGeoJSONFromAnUpdate(
          false
        );

        setAPIReportMessage(
          'Saved'
        );

      }, 100);

      setIsEditing(false);

    } catch (err) {

      console.error(
        'Error updating numeric metric:',
        err
      );

      setIsLoadingNewGeoJSONFromAnUpdate(
        false
      );

      setAPIReportMessage(
        'Save failed'
      );

    }
  };

  const handleCancel = () => {

    setIsEditing(false);

    setSelectedYearEditing(null);

  };

  if (
    !selectedMetric ||
    !selectedYearEditing
  ) {
    return null;
  }

  return (

    <div
      style={{
        position: 'relative',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingBottom: '10px'
      }}
    >

      <p
        className="editMetricPrompt"
        style={{
          backgroundColor:
            'rgb(222, 239, 231)',
          fontSize: '8px',
          marginBottom: '6px',
          width: '100%',
          textAlign: 'center',
          borderRadius: '5px',
          cursor:
            userIsMapOwner
              ? 'pointer'
              : 'default',
          pointerEvents:
            userIsMapOwner
              ? 'auto'
              : 'none',
          opacity:
            userIsMapOwner
              ? 1
              : 0.6
        }}

        onClick={
          userIsMapOwner
            ? handleEdit
            : undefined
        }
      >

        Click to Edit{' '}

        <b>
          {valuePropertyName}
        </b>

        {' '}at{' '}

        <b>
          {String(selectedYearEditing)}
        </b>

        <button
          className="editMetricAction"
          disabled={!userIsMapOwner}

          style={{
            fontSize: '9px',
            paddingLeft: '7px',
            paddingRight: '7px',
            paddingBottom: '6px',
            paddingTop: '6px',
            cursor:
              userIsMapOwner
                ? 'pointer'
                : 'not-allowed',
            marginLeft: '5px',
            top: '-5px',
            borderRadius: '20px',
            color: '#29645D',
            opacity:
              userIsMapOwner
                ? 1
                : 0.5
          }}
        >

          <FaPencilAlt />

        </button>

      </p>

      {/* ---------------- EDIT MODE ---------------- */}

      {isEditing && (

        <>

          <input
            type="number"
            value={inputValue}

            onChange={
              e =>
                setInputValue(
                  e.target.value
                )
            }

            placeholder={
              `Set ${selectedMetric}`
            }

            style={{
              padding: '4px',
              fontSize: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              width: '100px',
              marginBottom: '8px'
            }}
          />

          <div
            style={{
              display: 'inline-block',
              width: '150px',
              marginLeft: '0px',
              position: 'absolute',
              top: '25px'
            }}
          >

            <button
              className="altervaluesbuttonsConfirm"
              onClick={applyNumericValue}
            >
              <TiTick />
            </button>

          </div>

        </>

      )}

    </div>

  );
};

export default AlterNumericMetricsInline;
